import {
  toString1n9qg6fb0b5i8 as toString,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import { substring3saq8ornu0luv as substring } from './stringJs.mjs';
import { titlecaseChar2jyx3x8hfb89d as titlecaseChar } from './charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function titlecaseImpl(_this__u8e3s4) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  var uppercase = toString(_this__u8e3s4).toUpperCase();
  if (uppercase.length > 1) {
    var tmp;
    if (_this__u8e3s4 === _Char___init__impl__6a9atx(329)) {
      tmp = uppercase;
    } else {
      var tmp0 = charCodeAt(uppercase, 0);
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.text.plus' call
      var other = substring(uppercase, 1).toLowerCase();
      tmp = toString(tmp0) + other;
    }
    return tmp;
  }
  return toString(titlecaseChar(_this__u8e3s4));
}
//region block: exports
export {
  titlecaseImpl as titlecaseImpl1y8hpibh9ddrw,
};
//endregion

//# sourceMappingURL=_OneToManyTitlecaseMappings.mjs.map
